export const SCROLL_THRESHOLD = 215
export const HITS_PER_PAGE = 36
export const MAX_VALUES_PER_FACET = 1000

/**
 * BUSINESS RULE: Multi-tab layout (Products + Services)
 *
 * The Grande São Paulo region has a special layout with tabs to separate
 * product search from service search results. Other regions use a single
 * product listing without tabs.
 *
 * When this region displays tabs:
 * - The Twig skeleton is hidden (faster initial render)
 * - React shows tab-based content with Products and Services
 * - Each tab has its own Algolia index and content
 *
 * To change this behavior, update REGIONS_WITH_TABS array below.
 */
export const GRANDE_SAO_PAULO_REGION = 'grande_sao_paulo'

/**
 * List of regions that should display the tab-based layout.
 * Currently only Grande São Paulo has this feature.
 */
export const REGIONS_WITH_TABS = [GRANDE_SAO_PAULO_REGION] as const

export const GRID_SIZES = {
  aside: { initial: 12, md: 0, lg: 3 },
  content: { initial: 12, md: 9 }
} as const
